module.exports = __webpack_public_path__ + "img/step4.c028163d.png";